<template>
  <review-single-select
    v-model="expertReview"
    label="Is this an Expert Review?"
    :options="expertReviewOptions"
    :validations="validations"/>
</template>

<script>
import ReviewSingleSelect from './ReviewSingleSelect'

export default {
  name: 'ReviewItemExpertReview',
  components: { ReviewSingleSelect },
  model: {
    prop: 'review',
    event: 'change'
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    validations: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      expertReviewOptions: [
        {
          text: 'Yes',
          value: 'true'
        },
        {
          text: 'No',
          value: 'false'
        }
      ]
    }
  },
  computed: {
    expertReview: {
      get () {
        return this.review?.expertReview?.toString()
      },
      set (value) {
        this.$emit('change', { ...this.review, expertReview: value === 'true' })
      }
    }
  }
}
</script>
